import type { ComponentProps } from 'react'
import HealthLegal from '../components/HealthLegal'

type Props = ComponentProps<typeof HealthLegal>

export default function Step4_HealthLegal(props: Props) {
  return <HealthLegal {...props} />
}

